import { between } from 'polished'
import styled from 'styled-components'

export const Button = styled.a`
  cursor: pointer;
  display: inline-block;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  user-select: none;
  padding: 8px 16px 6px;
  transition: all 150ms ease;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-indent: 0;
  text-shadow: none;
  align-items: flex-start;
  text-transform: uppercase;
  font-size: ${between('14px', '18px')};
  font-weight: 700;
  letter-spacing: -1px;

  ${({ fluid }) =>
    fluid &&
    `
    width: 100%;
    display: block;
  `}

  ${({ theme, color }) => `
    font-family: ${theme.font[1]};
    color: ${theme.colors[color]};
    background-color: transparent;
    border: 3px solid ${theme.colors[color]};

    &:hover {
      color: ${theme.colors.light};
      background-color: ${theme.colors[color]};
    }
  `}

  ${({ theme, color, solid }) =>
    solid &&
    `
    color: ${theme.colors.light};
    background-color: ${theme.colors[color]};
  `}


  ${({ xl }) =>
    xl &&
    `
    font-size: ${between('18px', '24px')};
  `}
`
